import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Spider extends Mob {
	constructor(sprites, infoable = true) {
		super(sprites, StandardSheetAnimations.getAnimation("spider"), Spider.WALK_STEP * Game.MULT, Spider.RADIUS);
		this.width = Game.ENEMY_WIDTH;
		this.height = Game.ENEMY_HEIGHT;
		this.substAnimation("idle_e", 1, { row: 9, col: 0 });
		this.substAnimation("idle_w", 1, { row: 9, col: 0 });


		let traits = {
			clas: "enemy",
			race: "spider",
			openDoors: false,
			static: false,
			qi: BasicAI.QI_LOW,
			speed: Spider.WALK_STEP * Game.MULT,
			radius: Spider.RADIUS,
			runspeed: Spider.RUN_STEP * Game.MULT,
			timeWarns: Spider.TIME_WARNS,
			infoable: infoable
		}
		this.setMobTraits(traits)

	}
	init() {
		this.mc = jQuery("#template-mob").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}
Spider.RADIUS = 4;
Spider.WALK_STEP = 3;
Spider.RUN_STEP = 4;
Spider.TIME_WARNS = [250, 350];